export const homePageData = {
  flowPathArr: [
    { name: '大赛报名', time1: '2020.10.15', time2: '-2020.11.01' },
    { name: '作品提交', time1: '2020.11.11', time2: '-2020.11.24' },
    { name: '入围赛', time1: '2020.11.11', time2: '-2020.11.24' },
    { name: '复赛评选', time1: '2020.11.11', time2: '-2020.11.24' },
    { name: '总决赛&颁奖', time1: '2020.11.11', time2: '-2020.11.24' }
  ],
  groupArr: [
    {
      img: require('../assets/images/img_handle.png'),
      title: '游戏制作组',
      txtArr: [
        {
          txtTitle: '赛组介绍：',
          txtContent:
            '游戏制作是一项将创意想法付诸实现的过程，该赛组旨在让学生能参与游戏项目研发的实践中，通过迷你世界开发工具，零基础也可以享受快速创建自己的游戏。'
        },
        {
          txtTitle: '主题要求：',
          txtContent:
            '不限作品主题、不限玩法类型（包括但不限于：对战/模拟养成/角色扮演/塔防/冒险/跑酷/解密/体育竞技等），运用迷你世界开发者工具，创作出具有完整玩法规则的游戏作品！'
        },
        {
          txtTitle: '制作要求：',
          txtContent:
            '在《迷你世界》开发者模式下，运用插件、触发器或脚本等功能创作地图，并转换玩法模式，上传到迷你工坊，即可前往大赛网页投稿。'
        }
      ]
    },
    {
      img: require('../assets/images/img_earth.png'),
      title: '模型制作组',
      txtArr: [
        {
          txtTitle: '赛组介绍：',
          txtContent:
            '模型制作是体现游戏艺术风格的重要组成部分，该赛组旨在让学生发挥艺术创造力，通过迷你世界模型工具，制作出具有个性的创意模型作品。 '
        },
        {
          txtTitle: '主题要求：',
          txtContent:
            '不限作品主题、不限模型类型（包括但不限于：武器/工具/装备/玩具/食物/人物/动物/怪物/杂物/植物/建筑/装饰/家具/载具/机械等，不限动态或静态），使用迷你世界的模型制作工具，创作出个性的模型资源作品！'
        },
        {
          txtTitle: '制作要求：',
          txtContent:
            '运用《迷你世界》的模型制作工具（模型工作台/道具模型工作台/生物模型方块/自定义模型制作器等，选其一或结合运用)创作模型资源，并上传到资源工坊，即可前往大赛网页投稿。'
        }
      ]
    }
  ],
  prizeMoneyArr: [
    {
      img: require('../assets/images/img_handle.png'),
      title: '游戏制作组',
      detail1: [
        {
          bonus: '￥100000',
          place: '特等奖(x1)'
        },
        {
          bonus: '￥50000',
          place: '一等奖(x1)'
        },
        {
          bonus: '￥20000',
          place: '二等奖(x2)'
        },
        {
          bonus: '￥10000',
          place: '三等奖(x3)'
        }
      ],
      detail2: [
        {
          bonus: '￥2000',
          place: '优胜奖(x20)'
        },
        {
          bonus: '500',
          place: '入围奖(x200)'
        }
      ]
    },
    {
      img: require('../assets/images/img_earth.png'),
      title: '模型制作组',
      detail1: [
        {
          bonus: '￥10000',
          place: '特等奖(x1)'
        },
        {
          bonus: '￥5000',
          place: '一等奖(x1)'
        },
        {
          bonus: '￥3000',
          place: '二等奖(x2)'
        },
        {
          bonus: '￥1000',
          place: '三等奖(x3)'
        }
      ],
      detail2: [
        {
          bonus: '￥500',
          place: '优胜奖(x20)'
        },
        {
          bonus: '100',
          place: '入围奖(x200)'
        }
      ]
    }
  ],
  prizeTxtArr: [
    {
      img: require('../assets/images/img_red_flag.png'),
      title: '团体奖',
      txt: `<p>授予学校，依据参赛校对大赛的重视程度、作品数量质量、宣传报道（在学校官网上及时转发大赛动态、报道学校组织情况、获奖情况等）、校内初选及组织工作规范度等标准评选，设卓越贡献奖、十佳组织奖、优秀组织奖。</p>`
    },
    {
      img: require('../assets/images/img_note.png'),
      title: '指导教师奖',
      txt: `<p>授予指导学生获奖的老师。</p>`
    }
  ],
  starPlainArr: [
    {
      img: require('../assets/images/img_star1.png'),
      redTxt: '1亿',
      blackTxt: '扶持基金',
      detailTxt: '最高可享受100%分成，新入驻团队每月万元起补贴赛事奖金。'
    },
    {
      img: require('../assets/images/img_star2.png'),
      redTxt: '亿级',
      blackTxt: '流量扶持',
      detailTxt: '平台月活1亿以上，官方矩阵号粉丝3000万+。'
    },
    {
      img: require('../assets/images/img_star3.png'),
      redTxt: '平台',
      blackTxt: '技术支持',
      detailTxt: '从初阶到专业的开发工具满足不同群体；可实现丰富玩法。'
    },
    {
      img: require('../assets/images/img_star4.png'),
      redTxt: '1站式',
      blackTxt: '服务支持',
      detailTxt: '提供教学和专业技术指导，2周学会做开发者地图。'
    }
  ],
  judgesArr: [
    {
      name: '魏铭',
      position: '育碧中国副美术总监'
    },
    {
      name: '林大卫',
      position: '联岸信息科技执行董事'
    },
    {
      name: '梁思萍',
      position: '迷你世界运营总监'
    },
    {
      name: '吴桐',
      position: '迷你世界美术总监'
    },
    {
      name: '熊梓晋',
      position: '迷你世界高级策划'
    }
  ],
  newsArticleArr: [
    {
      url: 'https://www.mini1.cn/article/20201103/1487.html',
      text: '一一一一一一一'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1486.html',
      text: '二二二二二二二二二二二二'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '三三三三三三三三三三三三三三三三三三三三三三三三三三三三三三'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '四四四四四'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '五五五五五五五五'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '六六六六六六六六'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '七七七七七'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '八八八八八八八八八八八八八'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '9'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '10'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '11'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '12'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '13'
    },
    {
      url: 'https://www.mini1.cn/article/20201102/1485.html',
      text: '14'
    }
  ],
  introduceArr: [
    '迷你世界全国高校游戏开发者大赛，由第九届全国高校数字艺术设计大赛组委会、深圳市迷你玩科技有限公司共同举办，是工业和信息化部人才交流中心主办的第九届全国高校数字艺术设计大赛（NCDA大赛）的命题赛事之一。',
    '大赛旨在通过游戏创意设计制作发掘优秀的游戏人才和创意作品，坚持创新与实践并重，鼓励大学生充分发挥想像力，创作属于自己的游戏，致力打造高校游戏人才发掘、培养与孵化的赛事。'
    // '为帮助有创意的高校开发者在游戏生态内快速成长，《迷你世界》将为游戏新手开发者提供从创作工具、创作培训到作品发布推广全流程的支持，助力实现游戏创作梦想。'
  ],
  schoolImgArr: [
    require('../assets/images/img_Colleges0.jpg'),
    require('../assets/images/img_Colleges1.png'),
    require('../assets/images/img_Colleges2.png'),
    require('../assets/images/img_Colleges3.png'),
    require('../assets/images/img_Colleges4.png'),
    require('../assets/images/img_Colleges5.png'),
    require('../assets/images/img_Colleges6.png'),
    require('../assets/images/img_Colleges7.png'),
    require('../assets/images/img_Colleges8.png'),
    require('../assets/images/img_Colleges9.png'),
    require('../assets/images/img_Colleges10.png'),
    require('../assets/images/img_Colleges11.png'),
    require('../assets/images/img_Colleges12.png'),
    require('../assets/images/img_Colleges13.png'),
    require('../assets/images/img_Colleges14.png'),
    require('../assets/images/img_Colleges15.jpg'),
    require('../assets/images/img_Colleges16.jpg'),
    require('../assets/images/img_Colleges17.jpg'),
    require('../assets/images/img_Colleges18.jpg'),
    require('../assets/images/img_Colleges19.jpg'),
    require('../assets/images/img_Colleges20.jpg')
  ],
  sponsorshipImgArr: [
    require('../assets/images/img_sponsors1.png'),
    require('../assets/images/img_sponsors2.png')
  ]
};
export const geamGuideDtat = {
  entryStepArr: [
    {
      img: require('../assets/images/img_num2.png'),
      smallTitle: '免费下载迷你世界游戏',
      btnArr: [
        { name: '安卓下载', link: '' },
        {
          name: 'APP Store下载',
          link: ''
        }
      ]
    },
    {
      img: require('../assets/images/img_num3.png'),
      smallTitle: '免费自学教程攻略',
      btnArr: [
        {
          name: '游戏创作教程',
          link: 'https://www.mini1.cn/article/20200916/1446.html'
        },
        // {
        //   name: 'WIKI百科',
        //   link: 'https://www.mini1.cn/article/20200916/1446.html'
        // },
        { name: '触发器教程', link: 'https://developers.mini1.cn/cfqwiki/' }
      ]
    }
  ],
  bigImgArr: [
    {
      icon: require('../assets/images/img_num2.png'),
      smallTitle: '实名认证',
      explainTxt: '（完善个人信息并提交）',
      img: require('../assets/images/img_real_name.jpg')
    },
    {
      icon: require('../assets/images/img_num3.png'),
      smallTitle: '认证成功',
      explainTxt: '（可在游戏中使用开发者商店功能，开发者中心查看收益数据）',
      img: require('../assets/images/img_view_data.jpg')
    }
  ],
  captionsArr: [
    {
      label: '大赛报名：',
      time: '2020.12.7-2021.3.31',
      detail: [
        '（1）请下载迷你世界电脑客户端，通过游客登录、设置密码获取迷你号；',
        '（2）前往大赛的“报名投稿”—“个人信息”中登录迷你号，并提交个人参赛的基本信息；报名成功后可以加入【大赛交流QQ群①：973875622，大赛交流QQ群②：673014907】'
      ]
    },
    // {
    //   label: '开发者特训营：',
    //   time: '2020.12',
    //   detail: [
    //     '开发者特训营将通过线上直播+视频混合式互动教程和完整攻略，帮助高校学生快速入门，成为开发者。',
    //     '大赛导师团将全程指导参赛学校、团队及个人，对参赛选手及其团队提供一对一指导和支持，帮助参赛者实现创意落地。'
    //   ]
    // },
    {
      label: '校园初赛：',
      time: '2020.12.16-2021.3.31',
      detail: [
        '在《迷你世界》完成作品创作并公开上传，前往“报名投稿”—“作品信息”页面完成作品提交即可参赛。（注：投稿作品审核后将会在“参赛作品”页面中展示；初赛期间可不限次数更新自己的投稿作品，每次修改后会覆盖上一次提交的内容。）'
        // '使用其他游戏开发工具的参赛者，可以把报名个人信息、参赛作品DEMO和作品玩法介绍投稿至大赛邮箱：MNWUGDEC@mini1.cn'
      ]
    },
    {
      label: '初赛评审：',
      time: '2021.4.1-2021.4.7',
      detail: [
        '由大赛组委会评审团队，对投稿作品进行入围评选，以作品创意、质量等维度评选出入围省级复赛的名单。'
      ]
    },
    {
      label: '省级复赛：',
      time: '2021.4.8-2021.4.18',
      detail: [
        '由大赛导师团对复赛入围选手提供优化建议和技术指导，帮助参赛者完善和优化作品体验。'
      ]
    },
    {
      label: '复赛评审：',
      time: '2021.4.19-2021.4.22',
      detail: [
        '由大赛组委会评审团队，根据作品创意、质量、完成度等方面对复赛作品进行评选，评选出入围全国总决赛的名单。'
      ]
    },
    {
      label: '全国总决赛：',
      time: '2021.4.23-2021.4.29',
      detail: [
        '大赛组委会评审团队将根据大赛的评审标准，对总决赛入围作品进行最终评分，决选出大赛获奖名单。'
      ]
    },
    {
      label: '颁奖仪式：',
      time: '2021.11月',
      detail: [
        '举行第九届全国高校数字艺术设计大赛(NCDA)颁奖典礼，对大赛获奖者进行颁奖。荣获全国总决赛一等奖的学生，可获得颁奖仪式现场路演的资格，角逐最终的大赛特别奖！'
      ]
    }
  ],
  workRequireArr: [
    [
      '1、大赛支持个人或团队报名，默认投稿人为团队负责人，一切信息以团队负责人提供的为准。'
    ],
    // [
    //   '2、本次大赛不限开发工具，使用《迷你世界》进行作品创作的参赛者，可以获得开发者资格认证。'
    // ],
    [
      '2、本次大赛仅限使用《迷你世界》进行作品创作，具体如下：',
      '【游戏制作组】在《迷你世界》开发者模式下，运用插件、触发器或脚本等功能创作地图，并转换玩法模式，上传到迷你工坊。',
      '【模型制作组】运用《迷你世界》的模型制作工具（模型工作台/道具模型工作台/生物模型方块/自定义模型制作器等，选其一或结合运用）创作模型资源，并上传到资源工坊。'
    ],
    [
      '3、迷你世界作品公开上传的条件：',
      '迷你世界账号完成实名认证并绑定手机号码'
      // '（2）游戏内“我的家园”等级为2级以上。'
    ],
    [
      '4、投稿注意事项：',
      '投稿时间以外分享的作品或历史分享过的作品均无法投稿参赛；投稿作品需要“公开”分享；请勿选择“私有”；大赛期间不得取消分享，如取消分享或删除作品导致评审团无法查阅的，作品将视为无效弃权。'
    ],
    [
      '5、本次大赛参赛者可自由选择作品主题创作方向，并保证其作品为参赛者原创的作品，不存在盗用、侵犯任何第三方的著作权、商标权和其他合法权益的内容。并遵守国家法律法规，不得宣传色情、暴力、血腥等不良内容，不创作涉及婚恋、政治话题内容。'
    ],
    [
      '6、获奖作品一经投稿则视为允许官方进行相关专题、官网、微博、微信等推广中署名宣传。'
    ]
  ],
  standardArr: [
    {
      title: '【游戏制作组】',
      standard:
        '根据主题创意（30%）、玩法质量（30%）、美观设计（20%）、创作难度（20%）等维度进行评审，满分100分。',
      AngleArr: [
        {
          label: '主题创意：',
          txt: '从作品的主题创意、故事背景、剧情设计等方面考量；'
        },
        {
          label: '玩法质量：',
          txt: '从作品的玩法设计、玩法趣味性、新手指引等方面考量；'
        },
        {
          label: '美观设计：',
          txt: '从作品整体场景设计的合理性、美观度，局部模型的细节等方面考量；'
        },
        {
          label: '创作难度：',
          txt: '从开发者工具、插件工具、模型工具的应用能力等方面考量。'
        }
      ]
    },
    {
      title: '【模型制作组】',
      standard:
        '根据主题创意（20%）、美观设计（40%）、作品品质（40%）等维度进行评审，满分100分。',
      AngleArr: [
        {
          label: '主题创意：',
          txt: '从作品的主题寓意、创新度等方面考量；'
        },
        {
          label: '美观设计：',
          txt: '从作品的结构比例合理性、美观度等方面考量；'
        },
        {
          label: '作品品质：',
          txt: '从作品的像素精度、局部细节的精美度方面考量。'
        }
      ]
    }
  ],
  awardArr: [
    '1、本次大赛奖金及证书将由第九届全国高校数字艺术设计大赛组委会安排发放，获奖信息将在获奖名单公布后的十个工作日内进行收集，若未在规定时间内提供真实有效信息的，将视为自愿放弃奖励。',
    '2、若团体参赛的，大赛只对该团体投稿人负责，一切信息以投稿人沟通情况为准。',
    '3、大赛奖金会按照国家法律法规收缴个人所得税。'
    // '4、大赛证书原则上发放电子版证书。'
  ]
};
export const myWorksData = {
  awardArr: [
    {
      num: '1、',
      txt:
        '参赛者请务必填写并提交个人报名信息，报名提交后即可投稿作品参加比赛。'
    },
    {
      num: '2、',
      txt:
        '报名成功后可以加入【大赛交流QQ群①：973875622，大赛交流QQ群②：673014907】，大赛相关通知和答疑将在群内进行。'
    },
    {
      num: '3、',
      txt:
        '参赛者须保证提交信息的真实性，提交的信息仅用于大赛身份核实、评选、颁奖。'
    },
    {
      num: '4、',
      txt:
        '参赛者在“作品信息”页面进行作品投稿，选择参赛组别、参赛作品和填写参赛信息，并上传作品内相关截图，以便评审团更好的审阅你的作品。（如截图与参赛作品不符，将无法通过审核展示。）'
    },
    {
      num: '5、',
      txt:
        '所有投稿作品采取”提交作品 → 审核 →通过后作品在“参赛作品”页面展示”的流程。'
    },
    {
      num: '6、',
      txt:
        '每个赛组每人只能提交一份作品，在投稿截止前都可任意更新修改，每次修改后会覆盖上一次提交的投稿内容'
    }
  ]
};
